import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, HostListener, ViewChild, TemplateRef, OnChanges } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR, NgForm, FormControl } from '@angular/forms';
import { ValueAccessorHelper } from '@helpers/value-accessor-helper';
import * as _ from 'underscore';
//import { ThemePalette } from '@angular/material';

@Component({
  selector: 'app-custom-searchselect',
  templateUrl: './custom-searchselect.component.html',
  styleUrls: ['./custom-searchselect.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: CustomSearchSelectComponent, multi: true }
  ],
})

export class CustomSearchSelectComponent extends ValueAccessorHelper<any> implements OnInit, OnChanges {
  @Input() name: string;
  @Input() disabled: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() errorText: string;
  @Input() label: string;
  @Input() options: Array<any> = [];
  @Input() autocomplete: string = 'off';
  @Input() selectedArray: [];
  @Input() idColumn: string;
  @Input() lazyloading: boolean = false;
  //@Input() color: ThemePalette = 'primary';
  @Output() onselect: EventEmitter<any> = new EventEmitter();
  @Input() placeholder: string = 'Select';

  //dropdownItems = new FormControl();
  selectedItems = new Array<any>();
  dropdownSettings = {};
  optionList = [];

  // selected text display in dropdown whe choose drop down data.
  @Input() public displayName;

  // "ngModel" property binding when choose the dropdown data.
  @Input() public ngModelValue;

  @Output() public optionSelected: EventEmitter<any> = new EventEmitter();
  @ViewChild('defaultOptions', { static: false }) defaultOptionsRef: TemplateRef<any>;

  private _maxlength;
  @Input() set maxlength(max) {
    this._maxlength = max && parseInt(max, null) || 0;
  }

  get maxlength() {
    return this._maxlength;
  }

  constructor(private cdf: ChangeDetectorRef) {
    super();
    this.selectedItems = new Array<any>();
  }

  ngOnInit() {
    try {
      this.cdf.detectChanges();    

    } catch (ex) {
      throw ex;
    }
  }

  ngOnChanges() {
    this.dropdownSettings = {
      singleSelection: false,
      text: this.placeholder,
      enableCheckAll: false,  
      enableSearchFilter: true,
      clearAll:false,
      classes: "search-dropdown",
      showCheckbox: true,
      labelKey: "name",
      disabled: this.disabled,
      lazyLoading: this.lazyloading
    };
    this.idColumn = this.idColumn ? this.idColumn : 'Id';

    let dataOption = [];
    let that = this;
    _.each(this.options, function (x) {
      dataOption.push({ id: x[that.idColumn], name: x[that.displayName] });
    })

    this.optionList = dataOption;    
  } 

  onItemSelect(item: any) {
    let data = this.selectedItems.find(x => x.id == item.id);
    if (!data) {
      this.selectedItems.push(item);
    }
    
    this.bindOutput();
  }

  OnItemDeSelect(item: any) {
    let index = this.selectedItems.indexOf(item);
    this.selectedItems.splice(index, -1);
    this.bindOutput();
  }

  onSelectAll(items: any) {
    this.selectedItems = items;
    this.bindOutput();
  }

  onDeSelectAll(items: any) {
    this.selectedItems = [];
    this.bindOutput();
  }

  onFilterSelectAll(items: any) {
    this.selectedItems = items;
    this.bindOutput();
  }

  onFilterDeSelectAll(items: any) {
    this.selectedItems = [];
    this.bindOutput();
  }

  bindOutput() {
    let result = this.selectedItems?.length > 0 ? this.selectedItems.map(({ id }) => id) : []
    this.onselect.emit(result);
  }
}
